import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_StudentLocker } from "../shared/data.service";
import { LockerPersonUpdateRequest } from "../shared/LockerPersonUpdateRequest";
import * as moment from "moment";

@Component({
	selector: "app-student-edit-locker",
	templateUrl: "./student-edit-locker.component.html",
	styleUrls: ["./student-edit-locker.component.css"],
})
export class StudentEditLockerComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private StudentLockerService: DataService_StudentLocker
	) {}

	ngOnInit(): void {
		this.SelectedLockerPerson = this.dialogConfig.data.SelectedLockerPerson;
		this.SelectedPerson = this.dialogConfig.data.SelectedPerson;
		this.user = this.dialogConfig.data.user;

		this.loadLocker();

		this.StudentName = this.SelectedPerson.PersonName;

		this.AssignmentComment = this.SelectedLockerPerson.AssignmentComments;
	}

	////////////////////////////////////////
	// Data
	////////////////////////////////////////
	SelectedLockerPerson: any;
	SelectedPerson: any;
	user: any;

	StudentName: any;

	//Form
	LockerStatusID: any = 1;
	lstLockerStatus: any = [
		{
			ID: 1,
			Desc: "All",
		},
		{
			ID: 2,
			Desc: "Assigned",
		},
		{
			ID: 3,
			Desc: "Unassigned",
		},
	];

	SelectedLocker: any;
	lstLockerAll: any = [];
	lstLocker: any = [];

	AssignedDate: Date = new Date();

	LockerComment: any = "";
	AssignmentComment: any = "";

	errorMessage: any = "";

	////////////////////////////////////////

	////////////////////////////////////////
	// Load Data
	////////////////////////////////////////
	loadLocker() {
		var result = this.StudentLockerService.LockerSelectList(this.SelectedPerson.SchoolID);
		result.subscribe(
			(response) => {
				this.lstLockerAll = response;

				this.SelectedLocker = this.lstLockerAll[0];

				for (var i = 0; i < this.lstLockerAll.length; i++) {
					var next = this.lstLockerAll[i];

					if ((next.LockerID = this.SelectedLockerPerson.LockerID)) {
						this.SelectedLocker = next;
						break;
					}
				}

				this.UpdateLockerList();
			},
			(error) => {}
		);
	}

	UpdateLockerList() {
		if (this.LockerStatusID == 1) {
			this.lstLocker = this.lstLockerAll;
		} else if (this.LockerStatusID == 2) {
			this.lstLocker = this.lstLockerAll.filter((locker) => locker.PersonID > 0);
		} else if (this.LockerStatusID == 3) {
			this.lstLocker = this.lstLockerAll.filter((locker) => locker.PersonID == 0);
		}

		this.SelectedLocker = this.lstLocker[0];
		this.UpdateComments();
	}

	UpdateComments() {
		this.LockerComment = this.SelectedLocker.Comment;
	}

	////////////////////////////////////////

	////////////////////////////////////////
	// Buttons
	////////////////////////////////////////
	onEdit() {
		this.errorMessage = "";

		if (this.SelectedLocker == undefined) {
			this.errorMessage = "Select a locker";
			return;
		}

		if (this.LockerComment == "") {
			this.errorMessage = "Enter locker combination";
			return;
		}

		this.CheckAssigned();
	}

	CheckAssigned() {
		if (this.SelectedLocker.PersonID > 0 && this.SelectedLocker.PersonID != this.SelectedPerson.PersonID) {
			var AssignedErrorMsg = "Locker is already assigned to: " + this.SelectedLocker.AssignedTo + ".";

			this.confirmationService.confirm({
				key: "editError",
				acceptLabel: "Ok",
				rejectVisible: false,
				message: AssignedErrorMsg,
				header: "ERROR",
				icon: "fa",
				accept: () => {},
			});
		} else {
			this.FinishEdit();
		}
	}

	FinishEdit() {
		let parms: LockerPersonUpdateRequest = {
			LockerPersonID: this.SelectedLockerPerson.LockerPersonID,
			MoveInDate: moment(this.AssignedDate).format("MM/DD/YYYY"),
			AssignmentComment: this.AssignmentComment,
			LockerComment: this.LockerComment,
		};

		var result = this.StudentLockerService.LockerPersonUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Locker Assignment was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Locker Assignment",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////

	////////////////////////////////////////
	// Events
	////////////////////////////////////////
	onLockerStatusChange(val) {
		this.LockerStatusID = val;

		//Filter lockers
		this.UpdateLockerList();
	}

	onLockerChange(val) {
		this.SelectedLocker = val;

		//Update Comments (Should have combination)
		this.UpdateComments();
	}

	////////////////////////////////////////
}
